<template>
    <header>
        <div class="bar">
            <div class="title-container">
                <router-link to="/">
                    <img src="@/assets/title.svg" alt="" />
                </router-link>
            </div>
            <div class="menu">
                <div @click="toggleSubMenu('item1')">
                    <div class="menu-super">
                        關於協會
                        <div class="arrow-icon" :class="{ 'arrow-down': isSubMenuOpen.item1 }" style="width: 20px; height: 20px">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </div>
                    </div>
                    <div class="sub-menu" v-if="isSubMenuOpen.item1">
                        <router-link :to="{ name: 'AssociationIntro' }"> 協會介紹 </router-link>
                        <router-link :to="{ name: 'FaqPage' }"> 常見問題 </router-link>
                        <router-link :to="{ name: 'AnnualReport' }"> 年度報告 </router-link>
                        <router-link :to="{ name: 'DonationBoxMap' }"> 募捐箱地圖 </router-link>
                    </div>
                </div>
                <div @click="toggleSubMenu('item2')">
                    <div class="menu-super">
                        線上捐款
                        <div class="arrow-icon" :class="{ 'arrow-down': isSubMenuOpen.item2 }" style="width: 20px; height: 20px">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </div>
                    </div>
                    <div class="sub-menu" v-if="isSubMenuOpen.item2">
                        <router-link :to="{ name: 'OnlinePayment' }"> 單筆捐款 </router-link>
                        <router-link :to="{ name: 'RegularDonation' }"> 定期捐款 </router-link>
                        <router-link :to="{ name: 'ATMTransfer' }"> ATM轉帳 </router-link>
                        <router-link :to="{ name: 'PostalRemittance' }"> 郵政劃撥 </router-link>
                    </div>
                </div>
                <router-link :to="{ name: 'OnlineFoodDonation' }" @click="initSubMenu()"> 線上捐糧 </router-link>
                <router-link :to="{ name: 'OnlineSponsorship' }" @click="initSubMenu()">線上助養 </router-link>
                <div @click="toggleSubMenu('item3')">
                    <div class="menu-super">
                        公益義賣
                        <div class="arrow-icon" :class="{ 'arrow-down': isSubMenuOpen.item3 }" style="width: 20px; height: 20px">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </div>
                    </div>
                    <div class="sub-menu" v-if="isSubMenuOpen.item3">
                        <router-link :to="{ name: 'MaterialDonation' }"> 物資捐贈 </router-link>
                        <router-link :to="{ name: 'OnlineShopping' }"> 線上購物 </router-link>
                    </div>
                </div>
                <router-link :to="{ name: 'VolunteerRecruitment' }" @click="initSubMenu()"> 志工招募 </router-link>
                <router-link :to="{ name: 'ContactUs' }" @click="initSubMenu()"> 聯絡我們 </router-link>
                <div v-show="!hadToken" class="menu-button">
                    <router-link :to="{ name: 'LogIn' }" @click="initSubMenu()">登入</router-link>
                </div>
                <div v-show="hadToken" @click="toggleSubMenu('item4')">
                    <div class="menu-super">
                        會員資訊
                        <div class="arrow-icon" :class="{ 'arrow-down': isSubMenuOpen.item4 }" style="width: 20px; height: 20px">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </div>
                    </div>
                    <div class="sub-menu" v-if="isSubMenuOpen.item4">
                        <router-link :to="{ name: 'UserProfile' }"> 個人檔案 </router-link>
                        <router-link :to="{ name: 'MemberRecord' }"> 會員紀錄 </router-link>
                        <a @click="handleLogout()">登出</a>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const isSubMenuOpen = reactive({
    item1: false,
    item2: false,
    item3: false,
    item4: false,
});
const store = useStore();
const router = useRouter();

const toggleSubMenu = (item) => {
    for (const key in isSubMenuOpen) {
        isSubMenuOpen[key] = key === item ? !isSubMenuOpen[key] : false;
    }
};

const initSubMenu = () => {
    for (const item in isSubMenuOpen) {
        isSubMenuOpen[item] = false;
    }
};

const handleLogout = () => {
    store.dispatch("handleLogout");
    router.push({ name: "Home" });
};

const hadToken = ref(false);
hadToken.value = store.getters.getHadToken;

onMounted(() => {
    store.watch(
        () => store.getters.getHadToken,
        (newValue) => {
            hadToken.value = newValue;
        }
    );
});
</script>

<style scoped>
@media screen and (min-width: 768px) {
    .bar {
        width: 80%;
        max-width: 1920px;
        margin: 0 auto;
    }

    .menu {
        flex-direction: row; /* 橫向排列 */
        align-items: center; /* 垂直居中 */
    }

    .menu a,
    .menu div {
        text-align: center;
        text-decoration: none;
        color: #333;
    }
}

header {
    position: fixed;
    top: 0;
    width: 100%;
    height: 60px;
    background-color: #fff;
    z-index: 1000;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
}

.bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.title-container {
    padding-left: 8px;
    padding-top: 4px;
}

.title-container img {
    width: 196px; /* 調整 logo 寬度 */
    height: auto; /* 保持高度自動調整 */
}

.menu {
    background-color: #fff;
    max-height: calc(100vh - 80px);
    z-index: 10;
    display: flex;
    flex-direction: row; /* 設置橫向排列 */
    flex-wrap: wrap; /* 如果菜單過多，自動換行 */
    gap: 32px;
}

.menu a {
    text-decoration: none;
    color: #333;
}

.sub-menu {
    padding: 10px !important;
    position: absolute;
    background-color: #fff;
    top: 60px;
}

.sub-menu a {
    display: block;
    padding: 5px 0px;
    text-decoration: none;
    color: #666;
    text-align: left;
}

.menu-super {
    padding: 0px !important;
    display: flex !important;
    cursor: pointer;
}

.arrow-icon {
    padding: 0px !important;
    position: relative;
    top: 12px;
    transform: translateY(-50%);
    transition: transform 0.3s;
}

.arrow-down {
    transform: translateY(-50%) rotate(180deg);
}
</style>
